module.exports = __webpack_public_path__ + "img/1007.5bc58cd9.jpg";